import { useShowContext } from 'ra-core';
import { DocumentEmailSender } from '../shared/DocumentEmailSender';

export const POEmailModal = ({ open, onClose }: { open: boolean, onClose: () => void }) => {
    const { record } = useShowContext();

    return (
        <DocumentEmailSender 
            open={open} 
            onClose={onClose} 
            record={record} 
            resource="purchase_orders" 
        />
    );
};
